import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-[#1a1a1a] text-white overflow-hidden" data-id="element-387">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-388">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-389">
          {/* Left: Product Image - Image 2 */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-390">
            <div className="absolute inset-0 bg-[#C9A961]/20 blur-[120px] rounded-full" data-id="element-391" />
            <img src="https://cdn.magicpatterns.com/uploads/pjByjCrnKMTF3Gbdh7AKsp/2-comunicacion_magnetica.png" alt="Libro Comunicación Magnética" className="relative w-full max-w-md mx-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-392" />
          </motion.div>

          {/* Right: Problem Statement - Matching Image 2 text */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-393">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-394">
              Si hoy te cuesta que te{' '}
              <span className="text-[#C9A961]" data-id="element-395">tomen en serio</span>...
            </h2>

            <div className="space-y-6 text-xl text-gray-300 mb-10" data-id="element-396">
              <p className="text-2xl" data-id="element-397">
                <span className="font-bold text-white" data-id="element-398">Hablas...</span>{' '}
                <span className="text-gray-400" data-id="element-399">pero no diriges.</span>
              </p>
              <p className="text-2xl" data-id="element-400">
                <span className="font-bold text-white" data-id="element-401">Te entienden...</span>{' '}
                <span className="text-gray-400" data-id="element-402">pero no actúan.</span>
              </p>
              <p className="text-2xl font-light mt-8" data-id="element-403">
                Y eso te cuesta oportunidades.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#1a1a1a] to-black p-6 rounded-2xl border border-[#C9A961]/20" data-id="element-404">
              <p className="text-sm text-gray-500 mb-4 uppercase tracking-wider" data-id="element-405">
                El resultado que ya conoces:
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-406">
                {['Suena bien.', 'Luego vemos.', 'Te aviso.'].map((text, i) => <div key={i} className="bg-black/50 backdrop-blur-sm px-5 py-3 rounded-xl text-gray-300 border border-gray-700" data-id="element-407">
                    {text}
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}